import React from "react";
import StatCard from "../../../../components/StatCard";
import { CampaignStat } from "../../interface/shared";
import { CurrencyCode } from "../../../../shared/constants";

interface CampaignStatGridProps {
  stats: CampaignStat[];
  columns?: number;
  currency?: CurrencyCode;
  isLoading?: boolean;
}

const CampaignStatGrid: React.FC<CampaignStatGridProps> = ({
  stats,
  columns = 4,
  currency = "USD",
  isLoading = false,
}) => {
  const getGridCols = () => {
    const lgMapping: Record<number, string> = {
      1: "lg:grid-cols-1",
      2: "lg:grid-cols-2",
      3: "lg:grid-cols-3",
      4: "lg:grid-cols-4",
      5: "lg:grid-cols-5",
      6: "lg:grid-cols-6",
      7: "lg:grid-cols-7",
      8: "lg:grid-cols-8",
      9: "lg:grid-cols-9",
      10: "lg:grid-cols-10",
      11: "lg:grid-cols-11",
      12: "lg:grid-cols-12",
    };

    const lg = lgMapping[columns] || "lg:grid-cols-4";
    const base = "grid-cols-1";
    let md = "md:grid-cols-2";

    if (columns > 6) {
      md = "md:grid-cols-4";
    } else if (columns > 4) {
      md = "md:grid-cols-3";
    }

    return `${base} ${md} ${lg}`;
  };

  return (
    <div className={`grid ${getGridCols()} gap-2`}>
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          title={stat.title}
          value={stat.value}
          isLoading={isLoading}
          isCurrency={stat.isCurrency}
          isPercentage={stat.isPercentage}
          icon={stat.icon}
          currency={currency}
        />
      ))}
    </div>
  );
};

export default CampaignStatGrid;
